export const claimsAccountCrosswalkHistoryColumns = [
  'facility_npi',
  'billing_provider_id',
  'account_number',
  'claim_number',
  'snapshot_id',
  'meta_lineage_content_hash',
];
